import {HtmlTemplates} from "./html-templates";
import logger from "./logger";

export let LuckyShot = (() => {

	const trigger = document.querySelector('[data-toggle="luckyshot"]');
	const getModal = () => {
		return document.getElementById('LuckyShot')
	};
	const getOverlay = () => {
		return document.getElementById('LuckyShotOverlay')
	};

	const init = () => {
		if (getModal()) {
			logger.log('Reinit Lucky Shot!');
		} else {
			logger.log('Init Lucky Shot!');
			// create, then show modal
			createModal().then((html) => {
				document.getElementById('Wrapper').insertAdjacentHTML('afterend', html);
				// listen for close click
				getModal().querySelector('#closeLuckyShot').addEventListener('click', () => closeModal());
				// fetch game url
				getData()
					.then((data) => {
						// wait a little
						setTimeout(() => {
							logger.log(data);
							// if game found and LS modal not closed
							if (data.success && getModal()) {
								// check if user logged in
								redirectToGame(data.game_link.simple_name);
							}
						}, getRandomSearchDuration());
					})
			})
		}
	}

	const createModal = async () => {
		return await HtmlTemplates.getTemplate(HtmlTemplates.luckyShot, true);
	}

	//
	const getData = async () => {
		const data = await fetch(URL_API('getLuckyShotGame', 'games'));
		const res = await data.json();
		return res ? res : null;
	}

	const redirectToGame = (link) => {
		let overlay = getOverlay();
		let html = `<div class="wait">${LL('FOUND_ONE_GAME_TEXT')}</div>`;
		overlay.insertAdjacentHTML('afterend', html);
		overlay.style.display = "none";
		setTimeout(() => {
			logger.log(`Redirecting to: /game/${link}`);
			window.location.href = `/game/${link}`;
		}, 2000)
	}

	const closeModal = () => {
		getModal().remove();
	}

	const getRandomSearchDuration = (min = 1000, max = 3000) => {
		return Math.random() * (max - min) + min;
	}

	return {
		trigger, init
	}

})();
